import { useEffect, useState } from 'react';
import { API_BASE } from './api-base';
import { SOCIAL_POST_DRAFTS_SPEC, toggleOverride } from './dev-feature-toggles';

const GATE_TIMEOUT_MS = 1500;

let cached: Promise<boolean> | null = null;

export function socialPostDraftsEnabled(): Promise<boolean> {
  const forced = toggleOverride(SOCIAL_POST_DRAFTS_SPEC);
  if (forced !== undefined) return Promise.resolve(forced === 'true');
  if (cached) return cached;
  cached = (async () => {
    try {
      const res = await fetch(`${API_BASE}/api/flags/social-post-drafts`, {
        credentials: 'include',
        signal: AbortSignal.timeout(GATE_TIMEOUT_MS),
      });
      if (!res.ok) {
        cached = null;
        return false;
      }
      return ((await res.json()) as boolean) === true;
    } catch {
      cached = null;
      return false;
    }
  })();
  return cached;
}

export function useSocialPostDraftsEnabled(): boolean | undefined {
  const [enabled, setEnabled] = useState<boolean | undefined>(undefined);
  useEffect(() => {
    let live = true;
    void socialPostDraftsEnabled().then((on) => {
      if (live) setEnabled(on);
    });
    return () => {
      live = false;
    };
  }, []);
  return enabled;
}
